import { OrderPlanningRowAction, OrderPlanningRowActionProps, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { SeatingDriver } from "../../asset/SeatingDriver";

export class RowActionSeatDriver extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonSeatDriver;
    }

    override getButtonId(): string {
        return "buttonSeatDriver";
    }

    override getAdditionalProps() {
        return this.getFindNearAfterSlideoutProp();
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["driver1_id", "driver1_name", "tractor"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        if (this.toolPanel.table.id === "tableDriverManagement" && !modelRow.isNull("tractor"))
            this.addReason(reasonMap, "driver_seated", "Driver is already seated.");
        return;
    }

    override execute(props: OrderPlanningRowActionProps) {
        const modelRow = props.selectedRows[0]?.data;
        this.getButton().busy = true;
        SeatingDriver.showSlideout({
            id: modelRow.get("driver1_id"),
            name: modelRow.get("driver1_name"),
        }, { doAfterSlideOut: props.afterSlideout });
        this.getButton().busy = false;
    }
}
